import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import "./lessonsList.scss";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "../tabPanel/tabPanel";
import LmstableData from "../../../../library/custom/lmstableData/lmstableData";
import { useSelector, useDispatch } from "react-redux";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import { COLUMNS_LESSON_VIEW } from "../../courseConstant";
import TableRowAction from "../../../../library/custom/gridTable/TableRowAction";
import { useNavigate } from "react-router-dom";
import { LESSONDETAIL } from "../../../../constant/routeContant";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import {
  PAGE_SIZE,
  ORG_ID,
  USER_ID,
  API_STATUS,
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SW_HBN_CLIENT_PARTNER_PRI,
} from "../../../../constant/constant";
import SearchIcon from "@mui/icons-material/Search";
import DialogBox from "../../../../library/common/DialogBox";
import {
  checkPrivileges,
  hasAllPrivileges,
  showRighSideMenu,
} from "../../../../utils/rolesHelper";
import { InactiveClient } from "../../../../utils/helper";
import FilterCommonStatusSelect from "../../../admin/shared/FilterCommonStatusSelect";
import FilterListIcon from "@mui/icons-material/FilterList";
import Modal from "@mui/material/Modal";
import commonImages from "../../../../assets";

const LessonList = (props) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [value, setValue] = React.useState(0);
  const dispatch = useDispatch();
  const [status, setStatus] = useState(0);
  const LessondeleteStatus = props.LessondeleteStatus;
  const publishLessonStatus = props?.publishLessonStatus;
  const getLessonListData = props?.getLessonListData;
  const [open, setOpen] = useState(false);
  const deleteLesson = props?.deleteLesson;
  const setisdisable = props?.setisdisable;
  const isdisable = props?.isdisable;
  const [isTableLoading, setisTableLoading] = useState(false);
  // code start for edit Global
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openPopModal, setOpenPopModal] = useState(false);
  const [activeInActive, setActiveInActive] = useState({
    ACTIVE: false,
    INACTIVE: false,
  });

  const handleActiveInActiveChange = (event) => {
    const { value } = event.target;
    setActiveInActive((prevState) => {
      if (!prevState) return { ACTIVE: false, INACTIVE: false };
      const newState = {
        ...prevState,
        [value]: !prevState[value],
      };
      let status = "";
      if (newState.ACTIVE && !newState.INACTIVE) {
        status = true;
      } else if (!newState.ACTIVE && newState.INACTIVE) {
        status = false;
      }
      if (!newState.ACTIVE && !newState.INACTIVE) {
        dispatch(lmsAction.clearCategoryList());
      } else {
        const data = {
          pageNumber: 1,
          isGlobal: "",
          status: status,
        };
        props?.getategoryListData(data);
      }

      return newState;
    });
  };

  const handleChange = (event, newValue) => {
    setSearch("");
    setSelectedValue();
    props?.setIscloneBtnClick(false);
    setPage(1);
    setValue(newValue);
    setStatus(newValue);
    const data = {
      pageNumber: 1,
      pageSize: pageSize,
      search: search,
      catIds: selectedValue ? selectedValue : "",
      statusId: "",
      userId: USER_ID(),
      organisationId: ORG_ID(),
      status: newValue,
      isSendMail: false,
    };
    getLessonListData(data);
  };
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const handleClose = (event) => {
    event?.currentTarget.type === "button"
      ? setAnchorEl(event.currentTarget)
      : setAnchorEl(null);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { isLoading } = useSelector((state) => state.getLessonsList);
  const lessionListData = useSelector((state) => state.getLessonsList);
  const categoryListData = props?.categoryListData;
  const noRecourdCount = lessionListData?.data?.noOfRecords;

  const handleViewOnClick = (lessonId) => {
    navigate(LESSONDETAIL, {
      state: { lessonId: lessonId, isAdminLesson: true },
    });
  };
  const publishItem = (lessonId) => {
    const lessonData = {
      lessonId: lessonId,
      isPulish: true,
      orgId: parseInt(ORG_ID()),
    };
    props?.onSubmit(lessonData);
    setAnchorEl(null);
  };

  const unPublishItem = (lessonId) => {
    const lessonData = {
      lessonId: lessonId,
      isPulish: false,
      orgId: parseInt(ORG_ID()),
    };
    props?.onSubmit(lessonData);
    setAnchorEl(null);
  };

  useEffect(() => {
    if (
      LessondeleteStatus === API_STATUS.SUCCESS ||
      publishLessonStatus === API_STATUS.SUCCESS
    ) {
      props?.setOpenGrandAccess(false);
      dispatch(
        lmsAction.getLessonsList({
          search: "",
          pageSize: pageSize,
          pageNumber: page ?? 1,
          catIds: selectedValue ? selectedValue : "",
          status: status ? status : "",
          organisationId: ORG_ID(),
          isSendMail: false,
        })
      );
      handleClose();
    }
  }, [LessondeleteStatus, publishLessonStatus]);

  useEffect(() => {
    if (
      props?.cloneLessonData?.status === API_STATUS.SUCCESS &&
      props?.iscloneBtnClick
    ) {
      props?.setOpenGrandAccess(false);
      props?.toast("Clone Lesson Successfully");

      dispatch(
        lmsAction.getLessonsList({
          search: "",
          pageSize: pageSize,
          pageNumber: page ?? 1,
          catIds: selectedValue ? selectedValue : "",
          status: status ? status : "",
          organisationId: ORG_ID(),
          isSendMail: false,
        })
      );
      props?.setIscloneBtnClick(false);
      handleClose();
    }
  }, [props?.cloneLessonData]);

  useEffect(() => {
    if (lessionListData.status === API_STATUS.SUCCESS) setisdisable(false);
  }, [lessionListData.status]);

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteItem = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };
  const deletehandle = () => {
    if (InactiveClient()) return;
    setOpenModal(false);
    const data = {
      lessonId: selectedRow?.lessonId,
    };
    deleteLesson(data);
  };
  const isShowClient =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);
  const showMenu = showRighSideMenu();
  const showSafety =
    showMenu?.isSafety &&
    (isShowClient || hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI));
  const checkClientPartner =
    hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI) ||
    hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI);
  const showSW =
    showMenu?.isSW &&
    (isShowClient || hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI));

  const isShowClientClone = parseInt(ORG_ID()) !== parseInt(HBNEXT_ORG_ID);
  const CloneshowSafety =
    showMenu?.isSafety &&
    (isShowClientClone || hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI));

  const showSWClone =
    showMenu?.isSW &&
    (isShowClientClone || hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI));

  const columns = React.useMemo(() => {
    const headers = [...COLUMNS_LESSON_VIEW];
    headers.push({
      field: "",
      width: 75,
      sortable: false,
      disableClickEventBubbling: true,
      headerClassName: "lesson-action-header",
      filterable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        const DisablePublishBtn =
          rows.row?.isSaPublished === false &&
          rows.row?.isGlobal &&
          checkPrivileges([12, 11, 10]) &&
          parseInt(ORG_ID()) !== parseInt(HBNEXT_ORG_ID);

        return (
          <TableRowAction
            rows={rows}
            usingComp={"Lesson"}
            deleted={
              (!rows?.row?.isPublished &&
                checkPrivileges([12, 11]) &&
                isShowClient) ||
              (!rows?.row?.isPublished &&
                checkPrivileges([12, 11]) &&
                rows?.row?.isGlobal === false)
                ? "deleted"
                : ""
            }
            edit={
              (!rows?.row?.isPublished &&
                checkPrivileges([12, 11, 10]) &&
                isShowClient) ||
              (!rows?.row?.isPublished &&
                checkPrivileges([12, 11, 10]) &&
                rows?.row?.isGlobal === false) ||
              (rows?.row?.isGlobal &&
                !rows?.row?.isPublished &&
                (CloneshowSafety || showSWClone) &&
                !DisablePublishBtn &&
                parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
                checkClientPartner)
                ? "edit"
                : ""
            }
            view
            publish={
              checkPrivileges([12, 11, 10]) || isShowClient ? "publish" : ""
            }
            viewLabel={"View Lesson"}
            editLabel={"Edit Lesson"}
            deleteLabel={"Delete Lesson"}
            publishText={
              (rows?.row?.isPublished &&
                rows?.row?.isGlobal === false &&
                checkPrivileges([12, 11, 10])) ||
              (rows?.row?.isGlobal === true &&
                rows?.row?.isSaPublished === true &&
                rows?.row?.isPublished &&
                checkPrivileges([12, 11, 10])) ? (
                <span className={isdisable ? "disableclss" : ""}>
                  UnPublish Lesson{" "}
                </span>
              ) : (
                <span
                  className={
                    isdisable || DisablePublishBtn ? "disableclss" : ""
                  }
                >
                  Publish Lesson
                </span>
              )
            }
            viewOnClick={(row) => handleViewOnClick(row?.lessonId)}
            editOnClick={(row) =>
              !row?.isPublished && !InactiveClient()
                ? ((showSafety || showSW) &&
                    row?.isGlobal &&
                    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)) ||
                  (rows?.row?.isGlobal &&
                    !rows?.row?.isPublished &&
                    (CloneshowSafety || showSWClone) &&
                    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID))
                  ? editItem(rows?.row)
                  : navigate(`/lesson/edit/${row?.lessonId}`, {
                      state: { isCloneOf: row?.isCloneOf },
                    })
                : undefined
            }
            deleteOnClick={() =>
              checkPrivileges([12, 11]) ? deleteItem(rows?.row) : ""
            }
            publishOnClick={(row) => {
              if (InactiveClient()) {
                return true;
              } else {
                if (!isdisable) {
                  //return row?.isPublished
                  return (row?.isPublished &&
                    row?.isGlobal === false &&
                    checkPrivileges([12, 11, 10])) ||
                    (row?.isGlobal === true &&
                      row?.isSaPublished === true &&
                      row?.isPublished &&
                      checkPrivileges([12, 11, 10]))
                    ? (showSafety ||
                        showSW ||
                        parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)) &&
                      row?.isGlobal &&
                      parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
                      checkPrivileges([12, 11, 10])
                      ? unPublishItemPop(row)
                      : unPublishItem(row?.lessonId)
                    : row?.isSaPublished === false &&
                      (showSafety ||
                        showSW ||
                        parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)) &&
                      !DisablePublishBtn &&
                      checkPrivileges([12, 11, 10])
                    ? publishItem(row?.lessonId)
                    : row?.isSaPublished === false &&
                      row?.isGlobal &&
                      checkPrivileges([12, 11, 10])
                    ? ""
                    : publishItem(row?.lessonId);
                }
              }
            }}
            clone={
              (rows?.row?.isGlobal &&
                rows?.row?.isSaPublished &&
                rows?.row?.isPublished &&
                (CloneshowSafety || showSWClone) &&
                parseInt(ORG_ID()) !== parseInt(HBNEXT_ORG_ID)) ||
              (checkClientPartner &&
                parseInt(ORG_ID()) !== parseInt(LOGIN_ORG_ID()) &&
                rows?.row?.isGlobal &&
                rows?.row?.isSaPublished &&
                rows?.row?.isPublished)
                ? true
                : false
            }
            cloneLabel="Clone Lesson"
            cloneOnClick={() => handleCloneOnClick(rows?.row)}
          />
        );
      },
    });
    return headers;
  }, [lessionListData, pageSize, navigate, isdisable]);

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
    const data = {
      pageNumber: 1,
      pageSize: pageSize,
      search: searchText ? searchText : "",
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
    };
    getLessonListData(data);
    setPage(1);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  const handlePagignation = (newPage) => {
    setPage(newPage + 1);
    getLessonListData({
      pageNumber: newPage + 1,
      pageSize: pageSize,
      search: search,
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
    });
  };
  const handleSearch = () => {
    setAnchorEl(null);
    const data = {
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      search: search ? search : "",
      catIds: selectedValue,
      statusId: parseInt(value) === 0 ? 2 : parseInt(value) === 2 ? "" : 1,
      userId: parseInt(USER_ID()),
      orgId: parseInt(ORG_ID()),
      organisationId: ORG_ID(),
      status: value ? value : "",
    };
    getLessonListData(data);
    setOpen(false);
  };

  const [selectedValue, setSelectedValue] = useState();

  const onChangeCategoryType = (item) => {
    setSelectedValue(item?.target?.value);
  };

  const handleClear = (item) => {
    setSelectedValue("");
    setSearch("");

    getLessonListData({
      pageNumber: 1,
      pageSize: pageSize,
      search: "",
      catIds: "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
    });
    setAnchorEl(null);
    setOpen(false);
    setPage(1);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;

  const sendEmail = () => {
    getLessonListData({
      pageNumber: page,
      pageSize: pageSize,
      search: search,
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: true,
    });
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    getLessonListData({
      pageNumber: page,
      pageSize: newPazeSize,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
    });
  };
  const editItem = (rows) => {
    if (InactiveClient()) return;
    setOpenEditModal(true);
    setSelectedRow(rows);
  };

  const edithandle = (rows) => {
    if (InactiveClient()) return;
    setOpenEditModal(false);
    if (!selectedRow?.isPublished && !InactiveClient()) {
      navigate(`/lesson/edit/${selectedRow.lessonId}`);
    }
  };
  const unPublishItemPop = (rows) => {
    if (InactiveClient()) return;
    setOpenPopModal(true);
    setSelectedRow(rows);
  };
  const unpublishhandle = (rows) => {
    if (InactiveClient()) return;
    unPublishItem(selectedRow?.lessonId);
    setOpenPopModal(false);
  };
  const handleCloneOnClick = (row) => {
    const data = { lessonId: row?.lessonId };
    props?.cloneLesson(data);
    handleClose();
  };

  const handleModelClose = () => {
    dispatch(lmsAction.clearDeleteLesson(""));
    props?.setOpenGrandAccess(false);
  };

  const cleanedCourses = props?.DeletedCourse?.map((course) => course?.trim());

  return (
    <>
      <div className="lessonsList">
        <Grid container>
          <Modal
            open={props?.openGrandAccess}
            onClose={handleModelClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Grid container className="modalUsrContainer">
              <Grid md={6} xs={12}>
                <Box className="modalCustomUserBox">
                  <div
                    onClick={handleModelClose}
                    className="ClosegrandAccesstyle"
                  >
                    X
                  </div>
                  <div className="deleteLessonIcon">
                    <img
                      className="deleteIcon"
                      src={commonImages?.RedInfoFull}
                      width={"55"}
                      height={"55"}
                      alt="deleteIcon"
                    />
                  </div>
                  <div className="modalTitle">Error: Cannot Delete Lesson!</div>
                  <div className="modeldesc1">
                    This lesson is a part of the courses:
                    <span> {cleanedCourses?.join(", ")}</span>
                  </div>
                  <div className="modeldesc2">
                    Please remove it from these courses before deleting
                  </div>
                  <Grid container className="grandaccess">
                    <Grid item lg={5} xs={12} sm={3} md={3}></Grid>

                    <Grid item lg={5.5} xs={12} sm={3} md={3}></Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Modal>

          <Grid lg={5.5} xs={12}>
            {openModal && (
              <DialogBox
                open={openModal}
                rows={[]}
                header={"Confirm Deletion"}
                deletehandle={deletehandle}
                handleCloseModal={() => setOpenModal(false)}
                content={"Are you sure you want to delete this Lesson?"}
                view
              />
            )}
            {openEditModal && (
              <DialogBox
                open={openEditModal}
                rows={[]}
                header={"Confirm Edit"}
                deletehandle={edithandle}
                handleCloseModal={() => setOpenEditModal(false)}
                content={
                  "These changes made will be shared with all clients. Are you sure you want to update?"
                }
                view
                editIcon={true}
                deleteIcon={false}
              />
            )}
            {openPopModal && (
              <DialogBox
                open={openPopModal}
                rows={[]}
                header={"Confirm UnPublish"}
                deletehandle={unpublishhandle}
                handleCloseModal={() => setOpenPopModal(false)}
                content={
                  "This training has been mapped to a client’s portal. Are you sure you want to unpublish?"
                }
                view
                editIcon={true}
                deleteIcon={false}
              />
            )}
            <Box>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  className="tabcustom"
                  icon={
                    value === 0 ? (
                      <div className="totalV">
                        {value === 0 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  iconPosition="end"
                  label="All Lessons"
                />
                <Tab
                  className="tabcustom"
                  icon={
                    value === 1 ? (
                      <div className="totalV">
                        {value === 1 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  label="Published"
                  iconPosition="end"
                />
                <Tab
                  className="tabcustom"
                  icon={
                    value === 2 ? (
                      <div className="totalV">
                        {value === 2 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  iconPosition="end"
                  label="Unpublished"
                />
              </Tabs>
            </Box>
          </Grid>
          <Grid lg={6.5} xs={12}>
            <div className="rightFilter lmsDownloadData">
              <div className="div-download-email-right" onClick={sendEmail}>
                <span>
                  <img
                    src={downloadIcon}
                    className="DownLoadLogo"
                    alt="DownLoad Logo"
                  />
                </span>
                Download Data
              </div>

              <div className="filtertoolbox lmsCls">
                <div className="filter_of_caselisttoolBox">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>

                  <div className="filter_btn">
                    <button
                      aria-describedby={id}
                      variant="contained"
                      type="button"
                      name="btn"
                      onClick={(e) => handleClick(e)}
                    >
                      <FilterListIcon id="icn" /> Filters
                    </button>
                    <FilterCommonStatusSelect
                      id={id}
                      open={open1}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      handleApply={handleSearch}
                      handleClear={handleClear}
                      filterDate={false}
                      filterSelect
                      //filter={filter}
                      categoryType={categoryListData?.categoryList ?? []}
                      categoryOnChanges={onChangeCategoryType}
                      category={selectedValue}
                      filterStatus={false}
                      resetBtn={true}
                      label={"Category"}
                      activeInActive={activeInActive}
                      setActiveInActive={setActiveInActive}
                      handleActiveInActiveChange={handleActiveInActiveChange}
                      statusCheckbox={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>

        <Grid container>
          <TabPanel className="tabPanel" value={value} index={0}>
            {isTableLoading ? (
              ""
            ) : (
              <LmstableData
                lessionListDataAll={lessionListData}
                onPageChange={handlePagignation}
                page={page}
                isLoading={isLoading}
                columns={columns}
                handlePageSizeChange={handlePageSizeChange}
                pageSize={pageSize}
                tableClass={props.tableClass}
              />
            )}
          </TabPanel>
          <TabPanel className="tabPanel" value={value} index={1}>
            {isTableLoading ? (
              ""
            ) : (
              <LmstableData
                lessionListDataAll={lessionListData}
                onPageChange={handlePagignation}
                page={page}
                isLoading={isLoading}
                columns={columns}
                handlePageSizeChange={handlePageSizeChange}
                pageSize={pageSize}
                tableClass={props.tableClass}
              />
            )}
          </TabPanel>
          <TabPanel className="tabPanel" value={value} index={2}>
            {isTableLoading ? (
              ""
            ) : (
              <LmstableData
                lessionListDataAll={lessionListData}
                onPageChange={handlePagignation}
                page={page}
                isLoading={isLoading}
                columns={columns}
                handlePageSizeChange={handlePageSizeChange}
                pageSize={pageSize}
                tableClass={props.tableClass}
              />
            )}
          </TabPanel>
        </Grid>
      </div>
    </>
  );
};

export default LessonList;
